export default "__VITE_ASSET__BjR72XvQ__"